module.exports = __webpack_public_path__ + "static/media/physician01.90b9ca71.jpg";